export const NAVAGRAHA_PLANETS = [
  {
    name: 'Surya',
    label: 'Sun',
    top: '25%',
    left: '50%',
    circle: { cx: 12, cy: 12, r: 4.2 },
    lines: [
      [12, 1.5, 12, 5],
      [12, 19, 12, 22.5],
      [1.5, 12, 5, 12],
      [19, 12, 22.5, 12],
      [4.7, 4.7, 7.1, 7.1],
      [16.9, 16.9, 19.3, 19.3],
      [19.3, 4.7, 16.9, 7.1],
      [7.1, 16.9, 4.7, 19.3],
    ],
  },
  {
    name: 'Chandra',
    label: 'Moon',
    top: '30.9%',
    left: '66.1%',
    paths: ['M18 12A8 8 0 1 1 10 4a6 6 0 0 0 8 8z'],
  },
  {
    name: 'Budh',
    label: 'Mercury',
    top: '45.7%',
    left: '74.6%',
    circle: { cx: 12, cy: 11, r: 5 },
    paths: ['M7.5 8.5A5 5 0 0 0 16.5 8.5'],
    lines: [
      [12, 16, 12, 21.5],
      [8.5, 19.5, 15.5, 19.5],
    ],
  },
  {
    name: 'Shukra',
    label: 'Venus',
    top: '62.5%',
    left: '71.7%',
    circle: { cx: 12, cy: 8.5, r: 5.5 },
    lines: [
      [12, 14, 12, 22],
      [8, 19, 16, 19],
    ],
  },
  {
    name: 'Mangal',
    label: 'Mars',
    top: '73.5%',
    left: '58.6%',
    circle: { cx: 10, cy: 14, r: 5.5 },
    lines: [[14, 10, 21.5, 2.5]],
    polylines: [[16, 2.5, 21.5, 2.5, 21.5, 8]],
  },
  {
    name: 'Guru',
    label: 'Jupiter',
    top: '73.5%',
    left: '41.4%',
    paths: ['M17 4L9 13h12'],
    lines: [[14.5, 7, 14.5, 22]],
  },
  {
    name: 'Shani',
    label: 'Saturn',
    top: '62.5%',
    left: '28.3%',
    lines: [
      [10, 2, 10, 19.5],
      [7, 9, 15.5, 9],
    ],
    paths: ['M10 19.5Q10 23.5 16.5 21.5'],
  },
  {
    name: 'Rahu',
    label: 'North Node',
    top: '45.7%',
    left: '25.4%',
    paths: ['M4.5 13.5A7.5 7.5 0 0 0 19.5 13.5'],
    lines: [
      [4.5, 13.5, 4.5, 21.5],
      [19.5, 13.5, 19.5, 21.5],
    ],
  },
  {
    name: 'Ketu',
    label: 'South Node',
    top: '30.9%',
    left: '33.9%',
    paths: ['M4.5 10.5A7.5 7.5 0 0 1 19.5 10.5'],
    lines: [
      [4.5, 10.5, 4.5, 2.5],
      [19.5, 10.5, 19.5, 2.5],
    ],
  },
]
